import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog as DialogMUI,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  IconButton,
  styled,
} from "@mui/material";

export const Dialog = styled(DialogMUI)`
  @media (max-width: 400px) {
    font-size: 20px;
  }
`;

const TitleText = styled(Stack)`
  justify-content: center;
  align-items: center;
  text-align: center;

  font-size: 24px;
  font-weight: 600;

  @media (max-width: 400px) {
    font-size: 18px;
  }
`;

export const DialogWindow = ({
  title,
  content,
  actions = null,
  handleClose,
  withCloseButton = false,
  ...props
}) => {
  return (
    <Dialog open scroll="body" {...props}>
      {withCloseButton && (
        <Stack
          alignItems={"flex-end"}
          sx={{
            margin: 0,
            position: "absolute",
            top: 0,
            right: 0,
          }}
        >
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Stack>
      )}
      <DialogTitle>
        <TitleText>{title}</TitleText>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ margin: 1 }}>{actions}</DialogActions>
    </Dialog>
  );
};
